import { render, staticRenderFns } from "./Filter.vue?vue&type=template&id=2d1290b9&scoped=true"
import script from "./Filter.vue?vue&type=script&lang=js"
export * from "./Filter.vue?vue&type=script&lang=js"
import style0 from "./Filter.vue?vue&type=style&index=0&id=2d1290b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1290b9",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/RoadSinisters/Filter.vue
// module id = 1066
// module chunks = 31